module.exports = __webpack_public_path__ + "img/circle-play-icon.ae0b4d04.svg";